import request from '@/utils/request'

export const apiAccessLogListApi = (data) => {
  return request({
    url: 'ApiAccessLog/List',
    method: 'post',
    data,
  })
}
